<template>
    <f7-page class="page-setup-region">
        <f7-navbar :sliding="false">
            <f7-nav-left back-link="Trở lại"></f7-nav-left>
            <f7-nav-title sliding>CÀI ĐẶT CÁCH CHƠI</f7-nav-title>
        </f7-navbar>
        <f7-block inset strong>
            <h4>Miền Nam</h4>
            <ul class="list-style-none pl-1">
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_mn', $event)" :value="1" :checked="!!configs.display_mn"></f7-checkbox>
                        Cú pháp Sài Gòn
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_mn_mtay', $event)" :value="1" :checked="!!configs.display_mn_mtay"></f7-checkbox>
                        Cú pháp Miền Tây
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_mn_buonme', $event)" :value="1" :checked="!!configs.display_mn_buonme"></f7-checkbox>
                        Cú pháp Buôn Mê
                    </label>
                </li>
            </ul>
            <h4>Miền Bắc</h4>
            <ul class="list-style-none pl-1">
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_mb', $event)" :value="1" :checked="!!configs.display_mb"></f7-checkbox>
                        Cú pháp Sài Gòn
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_mb_mtay', $event)" :value="1" :checked="!!configs.display_mb_mtay"></f7-checkbox>
                        Cú pháp Miền Tây
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_mb_ngan', $event)" :value="1" :checked="!!configs.display_mb_ngan"></f7-checkbox>
                        Cú pháp Nghệ An
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_mb_buonme', $event)" :value="1" :checked="!!configs.display_mb_buonme"></f7-checkbox>
                        Cú pháp Buôn Mê
                    </label>
                </li>
            </ul>
            <h4>Miền Trung</h4>
            <ul class="list-style-none pl-1">
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_mt', $event)" :value="1" :checked="!!configs.display_mt"></f7-checkbox>
                        Cú pháp Sài Gòn
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_mt_mtay', $event)" :value="1" :checked="!!configs.display_mt_mtay"></f7-checkbox>
                        Cú pháp Miền Tây
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_mt_buonme', $event)" :value="1" :checked="!!configs.display_mt_buonme"></f7-checkbox>
                        Cú pháp Buôn Mê
                    </label>
                </li>
            </ul>
        </f7-block>
        <f7-block inset strong>
            <h4>Tính năng Cân hàng</h4>
            <ul class="list-style-none pl-1">
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_overpoint_function', $event)" :value="1" :checked="!!configs.display_overpoint_function"></f7-checkbox>
                        Bật
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeDisplayRegion('display_overpoint_function', $event)" :value="0" :checked="!configs.display_overpoint_function"></f7-checkbox>
                        Tắt
                    </label>
                </li>
            </ul>
            <h4>Làm tròn</h4>
            <ul class="list-style-none pl-1">
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeRoundUp('overpoint_round_up_config', $event)" value="none" :checked="configs.overpoint_round_up_config === 'none'"></f7-checkbox>
                        Giữ nguyên 1 số thập phân (VD: 0.x)
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeRoundUp('overpoint_round_up_config', $event)" value="default" :checked="configs.overpoint_round_up_config === 'default'"></f7-checkbox>
                        Làm tròn hàng đơn vị (VD: 0.4 => 0 , 0.7 => 1)
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeRoundUp('overpoint_round_up_config', $event)" value="up_half" :checked="configs.overpoint_round_up_config === 'up_half'"></f7-checkbox>
                        Làm tròn lên 1 số thập phân (VD: 0.4 => 0.5 , 0.7 => 1)
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeRoundUp('overpoint_round_up_config', $event)" value="up_full" :checked="configs.overpoint_round_up_config === 'up_full'"></f7-checkbox>
                        Làm tròn lên hàng đơn vị (VD: 0.4 => 1, 0.7 => 1)
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeRoundUp('overpoint_round_up_config', $event)" value="down_half" :checked="configs.overpoint_round_up_config === 'down_half'"></f7-checkbox>
                        Làm tròn xuống 1 số thập phân (VD: 0.4 => 0 , 0.7 => 0.5)
                    </label>
                </li>
                <li class="mb-1">
                    <label>
                        <f7-checkbox @change="changeRoundUp('overpoint_round_up_config', $event)" value="down_full" :checked="configs.overpoint_round_up_config === 'down_full'"></f7-checkbox>
                        Làm tròn xuống hàng đơn vị (VD: 0.4 => 0, 0.7 => 0)
                    </label>
                </li>
            </ul>
        </f7-block>
        <f7-block inset>
            <f7-button fill color="primary" @click.prevent="submitChangeDisplayRegion">
                LƯU THÔNG TIN
            </f7-button>
        </f7-block>
    </f7-page>
</template>
<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['user_info'])
    },
    data() {
        return {
            configs: {}
        }
    },
    methods: {
        changeDisplayRegion(name, event) {
            let val = parseInt(event.target.value);

            if (['display_mn_buonme', 'display_mb_buonme', 'display_mt_buonme'].indexOf(name) >= 0) {
                this.configs.display_mn = 0;
                this.configs.display_mn_mtay = 0;
                this.configs.display_mb = 0;
                this.configs.display_mt = 0;
                this.configs.display_mb_mtay = 0;
                this.configs.display_mt_mtay = 0;
                this.configs.display_mb_ngan = 0;
            }
            else if (['display_overpoint_function'].indexOf(name) < 0){
                this.configs.display_mn_buonme = 0;
                this.configs.display_mt_buonme = 0;
                this.configs.display_mb_buonme = 0;
            }

            if (event.target.checked) {
                this.configs[name] = val;
            }
            else{
                this.configs[name] = 0;
            }

            this.$forceUpdate();
        },
        changeRoundUp(name, event) {
            this.configs[name] = event.target.value;
        },
        submitChangeDisplayRegion() {
            this.$f7.preloader.show();
            this.$store.dispatch('changeMeConfig', this.configs)
                .then(() => {
                    this.$f7.preloader.hide();
                    this.$f7.dialog.alert('Đã cập nhật thành công', 'THÔNG BÁO', () => {
                        this.user_info.user_configs = this.configs;
                        if (this.$store.state.isset_region === 0) {
                            this.$store.commit('UPDATE_ISSET_REGION', 1);
                            this.$f7router.navigate('/');
                        }
                    })
                })
                .catch((err) => {
                    this.$f7.preloader.hide();
                    this.$f7.dialog.alert(err, 'LỖI!');
                })
        }
    },
    mounted() {
        this.configs = this._.cloneDeep(this.user_info.user_configs);
        if (typeof this.configs.display_mn_buonme === 'undefined'){
            this.configs.display_mn_buonme = 0;
        }
        if (typeof this.configs.display_mb_buonme === 'undefined') {
            this.configs.display_mb_buonme = 0;
        }
        if (typeof this.configs.display_mt_buonme === 'undefined') {
            this.configs.display_mt_buonme = 0;
        }
        if (this.$store.state.isset_region === 0 && this.$moment(this.user_info.first_login).format('DD/MM/YYYY') === this.$moment(new Date()).format('DD/MM/YYYY')) {
            this.configs.display_mn = 0;
            this.configs.display_mn_mtay = 0;
            this.configs.display_mb = 0;
            this.configs.display_mb_mtay = 0;
            this.configs.display_mb_ngan = 0;
            this.configs.display_mt = 0;
            this.configs.display_mt_mtay = 0;
            this.configs.display_mt_buonme = 0;
            this.configs.display_mn_buonme = 0;
            this.configs.display_mb_buonme = 0;
        }
    }
};
</script>
